import { gql } from "@apollo/client";

// トークン取得
export const GET_TOKEN = gql`
    query GetToken($input: GetTokenInput!) {
      getToken(input: $input) {
        token
      }
    }
`;

// 郵便番号から住所一覧を取得
export const GET_ADDRESS = gql`
  query ($input: GetAddressInput!) {
    getAddress(input: $input) {
      addressCdOptions {
        value
        label
      }
      errorResponse {
        errorMsg
      }
    }
  }
`;

// 余力情報を取得
export const GET_CAPACITY_INFO = gql`
  query GetCapacityInfo($input: GetCapacityInfoInput!) {
    getCapacityInfo(input: $input) {
      isOutOfArea
      capacityList {
        targetYmd
        hasCapacityAM
        hasCapacity1315
        hasCapacity1517
        hasCapacity1719
      }
      tntShopCdTgl
      errorResponse {
        errorMsg
        errorCd
      }
    }
  }
`;

// 担当店舗情報を取得
export const GET_TNTSHOP = gql`
  query ($input: GetTntShopInfoInput!) {
    getTntShopInfo(input: $input) {
      tntHjnCd
      tntShopCd
      tntShopName
      tntShopTelNo
      errorResponse {
        errorMsg
        errorCd
      }
    }
  }
`;

// 機器一覧を取得
export const GET_KIKI_LIST = gql`
  query GetKikiMtmrSelectList {
    getKikiMtmrSelectList {
      kikiMtmrSelectList {
        kbnName
        kikSelectiList {
          value
          label
        }
      }
    }
  }
`;

// お客さま情報を取得
export const GET_CUST_INFO = gql`
  query ($input: GetCustInfoInput!) {
    getCustInfo(input: $input) {
      custNo
      cstRegistNo
      shiyoKeiyakuNo
      errorResponse {
        errorMsg
      }
    }
  }
`;

// 登録処理を実施
export const CREATE_SHCH_MTMR = gql`
  mutation CreateShchMtmr($data: CreateShchMtmrInput!) {
    createShchMtmr(data: $data) {
      resultStatus
      uktkNo
      errorResponse {
        errorMsg
        errorCd
      }
    }
  }
`;

// MTGログイン情報を取得
export const GET_MEMBER_INFO = gql`
  query Query($kbn: String!, $code: String!) {
    getMemberInfo(kbn: $kbn, code: $code) {
      memberInfoList {
        gmtSetNo
        mailAddress
        sei
        mei
        seiKn
        meiKn
        telNo
        yubinNo
        addressCd
        address
        bant
        go
        bldName
        muneban
        heyaban
      }
      errorResponse {
        errorMsg
      }
    }
  }
`;